import { render } from "./LegacyBillingDialog.vue?vue&type=template&id=77acff6a&scoped=true"
import script from "./LegacyBillingDialog.vue?vue&type=script&lang=ts"
export * from "./LegacyBillingDialog.vue?vue&type=script&lang=ts"

import "./LegacyBillingDialog.vue?vue&type=style&index=0&id=77acff6a&lang=scss&scoped=true"
import "./LegacyBillingDialog.vue?vue&type=style&index=1&id=77acff6a&lang=scss"
script.render = render
script.__scopeId = "data-v-77acff6a"

export default script